module.exports = __webpack_public_path__ + "static/media/contacts-b.5697dcc7.svg";